<template>
  <div class="total-count">
    <span
      v-if="totalCount"
      class="total-number"
    >{{ totalCount }}</span>
    {{ $t(totalText, totalCount) }}
  </div>
</template>

<script lang="ts" setup>
defineProps({
  totalCount: {
    type: Number,
    required: true,
  },
  totalText: {
    type: String,
    default: 'No articles | article | articles',
  },
})
</script>

<style src="~layers/app/components/Paginator/TotalCount.css" scoped />
